import {  Image } from "@chakra-ui/react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { BiBot, BiUser } from "react-icons/bi";
import { BsRobot } from "react-icons/bs";
import { GrFormClose } from "react-icons/gr";
import { LuMessagesSquare } from "react-icons/lu";
import { Ri24HoursLine } from "react-icons/ri";
import { TbMessageDots } from "react-icons/tb";
import { TfiCommentsSmiley, TfiHeadphoneAlt } from "react-icons/tfi";


export const BotLogo=({botDetails,isColorDark})=>{
    return (
      <>
        {botDetails.bubbleIcon === "BsRobot" ? (
          <BsRobot
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "GrFormClose" ? (
          <GrFormClose
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "TbMessageDots" ? (
          <TbMessageDots
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "TfiHeadphoneAlt" ? (
          <TfiHeadphoneAlt
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "TfiCommentsSmiley" ? (
          <TfiCommentsSmiley
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "TAiOutlineQuestionCircle" ? (
          <AiOutlineQuestionCircle
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "Ri24HoursLine" ? (
          <Ri24HoursLine
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "LuMessagesSquare" ? (
          <LuMessagesSquare
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "BiBot" ? (
          <BiBot
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "BiUser" ? (
          <BiUser
            fontSize={"28px"}
            color={isColorDark(botDetails.accentColor) ? "white" : "black"}
          />
        ) : botDetails.bubbleIcon === "companyLogo" ? (
          <Image
            src={botDetails.companyLogo}
            w={"28px"}
            h={"28px"}
            borderRadius={"100px"}
          />
        ) : (
          <></>
        )}
      </>
    );
}